import React, { Fragment, useState, useEffect } from 'react';
import { Card, Form, Table, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { serviceGetProcesosJudiciales } from '../../../../../api/api-antecendentes-legales';
import Implicados from './implicados';


const Procesos = ({ cfg_form, situacion, setTotalesPagados, setValidateSituacion, loadProcesos, setProcesoSeleccionado}) => {
    const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
    const { llaves } = data_gestion_defensa;
    const [procesos, setProcesos] = useState([]);

    const [showImplicados, setShowImplicados] = useState(false);
    const [procesoSelected, setProcesoSelected] = useState(null);
    const [posProcesoSelected, setPosProcesoSelected] = useState(-1);
    const [fechaIngreso, setFechaIngreso] = useState("");
    const [radiosDisabled, setRadiosDisabled] = useState([]);
    const [pagoSubmit, setPagoSubmit] = useState(false);

    useEffect(() => {
        getProcesosJudiciales("ue1");
    }, [])

    useEffect(() => {
        if (loadProcesos) getProcesosJudiciales("uelp");
    }, [loadProcesos])

    useEffect(() => {
        if (pagoSubmit) { setPagoSubmit(false); getProcesosJudiciales("ueps") }
    }, [pagoSubmit])

    useEffect(() => {
        //calculateTotalPagado();
        
        if (situacion === "") {
            const auxBools = [];
            procesos.forEach(_ => auxBools.push(true));

            setRadiosDisabled(auxBools);
        }
    }, [procesos])

    useEffect(() => {
        const auxBools = [];

        procesos.forEach(proceso => {
            if (((situacion === "conPago" || situacion === "sinPago") && (proceso.estado !== 265002)) || situacion == "rechazo") auxBools.push(true);//
            else auxBools.push(false)
        });

        if (!procesoSelected || situacion !== "conPago") setShowImplicados(false);
        else setShowImplicados(true);

        setRadiosDisabled(auxBools);
    }, [situacion])

    const getProcesosJudiciales = async (from) => {
        let counter = 0; let counterRC = 0;

        let query = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso })).toString('base64');
        const response = await serviceGetProcesosJudiciales(query);
        response.forEach(proceso => { 
            if (proceso.estado !== 265001) counter++ 
            if (proceso.estado === 265003 || proceso.estado === 265004) counterRC++ 
        });

        setProcesos(response);
        setValidateSituacion({ tieneProcesoCerrado: counter > 0, todosEstadoCerrado: counter === response?.length, totalLength: response?.length, tieneProcesoCierreAplicado: counterRC > 0 });
        
        if (posProcesoSelected !== -1) {
            let procesoSeleccionado = response[posProcesoSelected];
            setProcesoSelected(procesoSeleccionado);
            
            let counterTP = 0;
            procesoSeleccionado?.implicados?.forEach(implicado => {
                if (implicado.montoApagar && implicado.montoApagar > 0) counterTP++;
            })
            setTotalesPagados(counterTP > 0);
        }
    }

    const handleImplicados = (selected, pos) => {
        if (situacion !== "sinPago") setShowImplicados(true);
        setProcesoSelected(selected);
        setPosProcesoSelected(pos);
        setFechaIngreso(selected?.fecIngresaCausa);

        let counter = 0;
        selected?.implicados?.forEach(implicado => {
            //if (!implicado.montoApagar || implicado.montoApagar === 0) counter++;
            if (implicado.montoApagar && implicado.montoApagar > 0) counter++;
        })
        setTotalesPagados(counter > 0);
        setProcesoSeleccionado(selected);
    }

    const calculateTotalPagado = () => {
        let counter = 0;

        procesos.forEach(proceso => {
            proceso?.implicados?.forEach(implicado => {
                if (!implicado.montoApagar || implicado.montoApagar === 0) counter++;
            })
        })

        setTotalesPagados(counter === 0);
    }

    return (
        <Fragment>
            <hr style={{ borderTop: '3px solid #04005D' }}></hr>
            <Card>
                <Card.Body className="customCard">
                    <Table striped className="customTable">
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center' }}></th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaprocesos-competencia"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaprocesos-jurisdiccion"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaprocesos-dptomun"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaprocesos-nroradicado"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaprocesos-fecingcasusa"]}</th>
                                <th style={{ textAlign: 'center', width: '12%' }}>{cfg_form && cfg_form["modalgestioncierre-grillaprocesos-ulthito"]}</th>
                                <th style={{ textAlign: 'center', width: '10%' }}>{cfg_form && cfg_form["modalgestioncierre-grillaprocesos-fechahito"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalgestioncierre-grillaprocesos-estado"]}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {procesos.map((proceso, index) => (
                                <tr key={index}>
                                    <td >
                                        <Form.Check
                                            type="radio"
                                            name="group1"
                                            id={`radio-${index}`}
                                            onChange={() => handleImplicados(proceso, index)}
                                            disabled={radiosDisabled[index]}
                                        />
                                    </td>
                                    <td>{proceso.competencia}</td>
                                    <td>{proceso.juridiccion}</td>
                                    <td>{proceso.departamento}/{proceso.municipio}</td>
                                    <td>{proceso.rolCausa}</td>
                                    <td>{proceso.fecIngresaCausaFormat}</td>
                                    <td>{proceso.glosaUltimoHito}</td>
                                    <td>{proceso.fecUltHitoJudicialFormat}</td>
                                    <td>{proceso.glosaEstado}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    {procesos?.length === 0 &&
                        <span style={{ display: 'inherit', textAlign: 'center' }}>No hay registros encontrados.</span>
                    }
                </Card.Body>
            </Card>

            {showImplicados &&
                <Implicados
                    cfg_form={cfg_form}
                    implicados={procesoSelected?.implicados}
                    fechaIngreso={fechaIngreso}
                    setPagoSubmit={setPagoSubmit}
                    procesoSelected={procesoSelected}
                />}

            <style type='text/css'>
                {`
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                    }
                    .customTable > thead {
                        color: white; 
                        background-color: rgb(114, 139, 176);
                    }
                    .customTable > thead > tr > th {
                        padding: 20px 0;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default Procesos;